import { ServiceState } from '@ekkogmbh/apisdk';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

const STATE_COLOR: Record<ServiceState, string> = {
  [ServiceState.ONLINE]: 'success.main',
  [ServiceState.OFFLINE]: 'error.main',
  [ServiceState.UNKNOWN]: 'text.disabled',
};

const STATE_LABEL: Record<ServiceState, string> = {
  [ServiceState.ONLINE]: 'Online',
  [ServiceState.OFFLINE]: 'Offline',
  [ServiceState.UNKNOWN]: 'Unknown',
};

interface Props {
  state?: ServiceState;
  showLabel?: boolean;
  shadowed?: boolean;
}

/** A small colored dot (green/red/grey) for service state, with optional label. */
export const StatusDot = ({ state, shadowed = false, showLabel = true }: Props): React.JSX.Element => {
  const resolved = state ?? ServiceState.UNKNOWN;
  const color = STATE_COLOR[resolved];
  return (
    <Stack direction={'row'} alignItems={'center'} spacing={0.75}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
      {showLabel && (
        <Typography variant={'caption'} sx={{ color, fontWeight: 600, pt: 0.5 }}>
          {shadowed ? 'Shadowed' : STATE_LABEL[resolved]}
        </Typography>
      )}
    </Stack>
  );
};
